$(document).ready(function() {
    
    $('.faq-section-question-heading').on('click', function() {
        $(this).find('i').toggleClass('fas fa-angle-up fas fa-angle-down');
        $(this).closest('.faq-section-question').find('.faq-section-question-answer').slideToggle();
        $(this).closest('.faq-section-question').find('.faq-section-question-heading i').toggleClass('active');
        $(this).closest('.faq-section-question').find('.faq-section-question-heading h2').toggleClass('active');
    });

    $(".product-images-container").slick({
        dots: false,
        fade: true,
        arrows: false, 
        slidesToScroll: 1,
      	asNavFor: '.product-images-nav-container'
    });
  
    $('.product-images-nav-container').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.product-images-container',
      dots: true,
      centerMode: true,
      focusOnSelect: true
    });
				

    $( ".product-faq-tab" ).addClass( "border-bottom-active" );

    $('.product-faq-tab').on('click', function() {
        $(".product-review-tab").removeClass("border-bottom-active");
        $(".product-faq-tab").addClass('border-bottom-active');
        $('.product-reviews-text').css('display', 'none');
        $('.product-faq-text').fadeToggle();
    });

    $('.product-review-tab').on('click', function() {
        $(".product-faq-tab").removeClass("border-bottom-active");
        $(".product-review-tab").addClass('border-bottom-active');
        $('.product-faq-text').css('display', 'none');
        $('.product-reviews-text').fadeToggle();
    });
  
  $('p, .visually-hidden, .product-card__title, .image-bar__caption, .site-footer__linklist-item, .product-single__title').each(function() {
    $(this).html(function () {
    	return $(this).html().replace("Chipex", "Chipex&#8482;"); 
	});
  });

  let searchParams = new URLSearchParams(window.location.search);
  let param = searchParams.get('VRN');
  if (param) {
    $('.reg-lookup-result .background-white').hide();
  }
});


$(window).on('load', function() {
  setTimeout(function() {
    $('.product-recommendations__inner .product-card__title').each(function() {
      $(this).html(function () {
          return $(this).html().replace("Chipex", "Chipex&#8482;"); 
      });
  	});
  }, 3000);
});